<div class="cont">
  <div class="pic">
    <img src="assets/img/guidance4.png"/>
    <canvas id="canvas" class="canvas"></canvas>
    <div>
      <canvas id="canvas3" class="canvas3"></canvas>
    </div>
  </div>
  <div class="pic">
    <img src="assets/img/guidance5.png"/>
  </div>
</div>